var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"nexia-logo",attrs:{"src":require("@/assets/nexia-logo-white.png"),"alt":"Nexia"}})
}
var staticRenderFns = []

export { render, staticRenderFns }